import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle } = FiIcons;

export default function Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'StudioSign | Welcome';
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center relative overflow-hidden">
      <div className="absolute w-[600px] h-[600px] bg-emerald-500/5 blur-[140px] rounded-full pointer-events-none" />

      <div className="w-full max-w-md bg-white/5 backdrop-blur-2xl border border-white/10 rounded-3xl p-10 flex flex-col items-center text-center relative z-10 mx-4">
        {/* Animated check */}
        <div className="w-20 h-20 rounded-full bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mb-8 animate-pulse">
          <SafeIcon icon={FiCheckCircle} className="text-4xl text-emerald-400" />
        </div>

        <h1 className="text-3xl tracking-tight mb-2">
          <span className="font-medium text-zinc-400">Studio</span>
          <span className="font-extrabold text-white">Sign</span>
        </h1>

        <h2 className="text-xl font-bold text-white mt-4 mb-3 tracking-tight">
          Account verified.
        </h2>

        <p className="text-sm text-zinc-400 leading-relaxed mb-10 max-w-xs">
          Your email has been confirmed and your account is ready. Welcome to StudioSign.
        </p>

        <button
          onClick={() => navigate('/admin', { replace: true })}
          className="w-full bg-white text-black font-semibold tracking-wide py-3.5 rounded-xl hover:bg-zinc-200 transition-colors duration-300 ease-out"
        >
          Enter Dashboard
        </button>
      </div>
    </div>
  );
}